import {
  INucleofectionInternalAction,
  NucleofectionInternalAction,
} from "./action";
import { INucleofectionInternalState } from "./initial-state";

export function NucleofectionInternalReducer(
  state: INucleofectionInternalState,
  action: INucleofectionInternalAction
) {
  switch (action.type) {
    case NucleofectionInternalAction.SET_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case NucleofectionInternalAction.SET_NEXT_STEP:
      return {
        ...state,
        step: state.step + 1,
      };
    case NucleofectionInternalAction.SET_PREV_STEP:
      return {
        ...state,
        step: state.step - 1,
      };
    case NucleofectionInternalAction.UPDATE_METHOD_SETTINGS:
      return {
        ...state,
        methodSettings: {
          ...state.methodSettings,
          [action.payload.key]: action.payload.value,
        },
      };
    case NucleofectionInternalAction.SET_UPLOADED_NUCLEOFECTION_PLATE:
      return {
        ...state,
        uploadedNucleofectionPlate: action.payload.uploadedNucleofectionPlate,
      };
    case NucleofectionInternalAction.SET_SELECTED_NUCLEOFECTION_WELLS:
      return {
        ...state,
        selectedNucleofectionWells: action.payload.selectedNucleofectionWells,
      };
    case NucleofectionInternalAction.SET_DEST_SELECTION_PROCESS:
      return {
        ...state,
        destSelectionProcess: action.payload.destSelectionProcess,
      };
    case NucleofectionInternalAction.SET_HOVER_WELL_ID:
      return {
        ...state,
        hoverWellId: action.payload.hoverWellId,
      };
    case NucleofectionInternalAction.SET_SELECTED_INTERMEDIATE_WELLS:
      return {
        ...state,
        selectedIntermediateWells: action.payload.selectedIntermediateWells,
      };
    case NucleofectionInternalAction.SET_WORKLIST:
      return {
        ...state,
        worklist: action.payload.worklist,
        worklistPreviewOpen: action.payload.worklistPreviewOpen,
      };
    case NucleofectionInternalAction.SET_WORKLIST_PREVIEW_OPEN:
      return {
        ...state,
        worklistPreviewOpen: action.payload.worklistPreviewOpen,
      };
    case NucleofectionInternalAction.SET_OPTIONAL_WARNINGS:
      return {
        ...state,
        optionalWarnings: action.payload.optionalWarnings,
      };
    case NucleofectionInternalAction.SET_REQUIRED_WARNINGS:
      return {
        ...state,
        requiredWarnings: action.payload.requiredWarnings,
      };
    case NucleofectionInternalAction.UPDATE_METHOD_SETTINGS_FROM_UPLOAD:
      return {
        ...state,
        methodSettings: action.payload.methodSettings,
      };
    case NucleofectionInternalAction.SET_NUCLEOFECTION_ALREADY_RESERVED:
      return {
        ...state,
        isNucPlateAlreadyReserved: action.payload.isNucPlateAlreadyReserved,
      };
  }
}
